import axios from "./axiosInstance";
import { PaymentMethodsApiResponse } from "../types/paymentMethodTypes";

/**
 * Get all payment methods
 */
export const getAllPaymentMethods = async (): Promise<PaymentMethodsApiResponse> => {
  const response = await axios.get<PaymentMethodsApiResponse>("/reference/payment-methods");
  return response.data;
};
